<template>
<div class="chapter">
<div class="inner_page">
<p class="half-title"><a id="page_xxviii"></a><a id="page_xxix"></a><strong>Visual Culture in the Modern Middle East</strong></p>
<p class="half-line">
</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle01.vue?470c45f6